import axios from "@/api/axios";

const tasksAdd = (data) => {
    return axios
        .post('/admin/tasks/tasks-add', {tasks: data})
        .then(response => response.data)
}

const tasksEdit = (data) => {
    return axios
        .post('/admin/tasks/tasks-edit', {tasks: data})
        .then(response => response.data)
}

const tasksRemove = (data) => {
    return axios
        .post('/admin/tasks/tasks-remove', {tasks: data})
        .then(response => response.data)
}

const tasksCheck = (data) => {
    return axios
        .post('/admin/tasks/tasks-check', {tasks: data})
        .then(response => response.data)
}

export default {
    tasksAdd,
    tasksEdit,
    tasksRemove,
    tasksCheck
}